module.exports = __webpack_public_path__ + "static/img/pe.c0d3dc98.svg";